const normalizedCount = (value) => {
  if (value == null || value === '') return null;
  const count = Number(value);
  return Number.isSafeInteger(count) && count >= 0 ? count : null;
};

/**
 * Keep the last proved count while navigation/list generations are crossing.
 * A real zero replaces the prior value; only an unavailable value falls back.
 */
export const resolveSportsnewRailLastGoodCount = ({ registry, key, current }) => {
  if (!(registry instanceof Map) || !key) return normalizedCount(current);

  const count = normalizedCount(current);
  if (count != null) return count;

  return registry.get(String(key)) ?? null;
};

export const commitSportsnewRailLastGoodCounts = ({ registry, entries }) => {
  if (!(registry instanceof Map) || !(entries instanceof Map)) return;
  for (const [key, value] of entries) {
    const count = normalizedCount(value);
    if (key && count != null) registry.set(String(key), count);
  }
};

export default resolveSportsnewRailLastGoodCount;
